// extracted by mini-css-extract-plugin
export default {"inlineIconBox":"InfoIcon_inlineIconBox__gbnY+","icon":"InfoIcon_icon__M0TER","pop":"InfoIcon_pop__YcHG+"};